export async function markdownToHtml(markdown) {
    // Regular expressions for matching markdown patterns
    const headerRegex = /^#+\s(.*)$/
    const paragraphRegex = /.+/
    const boldRegex = /\*\*(.*?)\*\*/g
    const italicRegex = /__(.*?)__/g
    const listRegex = /^(?:\*|-)\s(.*)$/gm

    const lines = markdown.split("\n")
    let html = []

    for (const line of lines) {
        if (line.match(headerRegex)) {
            //
            const headerLevel = line.match(/#/g).length
            const headerText = line.replace(headerRegex, "$1")
            html.push(`<h${headerLevel}>${headerText}</h${headerLevel}>`)
        } else if (line.match(paragraphRegex)) {
            //
            html.push(`<p>${line}</p>`)
        } else if (line.match(listRegex)) {
            //
            const listItemText = line.replace(listRegex, "$1")
            html.push(`<li>${listItemText}</li>`)
        } else {
            html.push(line)
        }
    }

    // Convert bold and italic markdown to HTML tags
    html = html.map((line) =>
        line
            .replace(boldRegex, "<strong>$1</strong>")
            .replace(italicRegex, "<i>$1</i>")
    )

    // Wrap list items with <ul> tags
    html = html.join("").replace(/<li>(.*?)<\/li>/g, "<ul><li>$1</li></ul>")

    return html
}
